/**
 * cmdk value/keyword derivation for the city comboboxes.
 *
 * cmdk identifies items by their `value` string — two items sharing a value
 * are treated as one (both render `data-selected`, and keyboard/pointer
 * selection cannot tell them apart; see cmdk's selected check
 * `state.value === item.value`). City labels are NOT unique: two cities can
 * render the same label (e.g. homonym municipalities with `state: null`),
 * so the item value must carry the city id. The visible label is matched by
 * the filter via cmdk's `keywords` prop — the default filter scores the
 * search input against `value + " " + keywords.join(" ")`
 * (cmdk 1.1.1 command-score).
 */
export interface ComboboxCity {
  id: number;
  name: string;
  state: string | null;
}

/** Human-readable label, e.g. "Dallas, TX" or "Querétaro". */
export function cityLabel(city: ComboboxCity): string {
  return `${city.name}${city.state ? `, ${city.state}` : ""}`;
}

/** Unique cmdk item value — the city id, never the (collidable) label. */
export function cityOptionValue(city: ComboboxCity): string {
  return String(city.id);
}

/** Keywords so cmdk's filter matches what the user actually sees. */
export function cityOptionKeywords(city: ComboboxCity): string[] {
  return [cityLabel(city)];
}
